export const FORCED_MARGIN_WIDTH = 24;
export const NAV_BUTTON_WIDTH = 55;
export const MAX_MARGIN_WIDTH = 100;
export const SMALL_SLIDER_THUMBNAIL_WIDTH = 320;
export const BIG_SLIDER_THUMBNAIL_WIDTH = 672;
